import { request } from "../../Services/Api"

export const getBalance = (params) => request.api.get(`/payments/balance/`, params)
export const updateBalance = ({ user_id, ...newInfo }) =>
  request.api.patch(`/payments/balance/`, newInfo, { params: { user_id } })
export const setAutoTopUp = (data) => request.api.patch(`/payments/balance/auto-top-up/`, data)
export const topUpBalance = (data) => request.api.post(`/payments/balance/`, data)
export const firstTopUpBalance = (data) => request.api.post(`/payments/balance/first-topup/`, data)

export const getBalanceActivity = (params) => request.api.get(`/payments/balance-activity`, params)
export const getBalanceActivityExport = ({ file_name, ...params }) =>
  request.api.get(`/payments/balance-activity/export-balance-activity/`, params)

export const getBalanceActivityFilterOptions = (params) =>
  request.api.get(`/payments/balance-activity/filter_options`, params)

export const getUsageOverview = (params) =>
  request.api.get(`/payments/balance-activity/usage-overview`, params)
export const postUsageOverviewExport = (params) =>
  request.api.get(`/payments/balance-activity/usage-overview/export/`, params)
